/**
 * TanStack Query hooks for `anura-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	anuraIntegrationQueryKeys,
	type CreateAnuraIntegrationBody,
	type ListAnuraIntegrationResponse,
	type AnuraIntegrationRow,
} from "./api";

export function useAnuraIntegrationList(): UseQueryResult<ListAnuraIntegrationResponse, Error> {
	return useQuery({
		queryKey: anuraIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useAnuraIntegrationCreate(): UseMutationResult<AnuraIntegrationRow, Error, CreateAnuraIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: anuraIntegrationQueryKeys.all });
		},
	});
}

export function useAnuraIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: anuraIntegrationQueryKeys.all });
		},
	});
}
